import Vue from 'vue';
import Vuex from 'vuex';
import BaseModule from '@/store/modules/BaseModule';
import LocalizationModule from '@/store/modules/LocalizationModule';
import FilterModule from '@/store/modules/FilterModule';
import SearchModule from '@/store/modules/SearchModule';
import RootState from '@/store/states/Root';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence<RootState>({
  storage: window.localStorage,
  key: 'searchResultsStorage',
  reducer: (state) => ({ base: { activeLayout: state.base.activeLayout } }),
});
// Order of the following modules is very important. Please keeping like that!
const store = new Vuex.Store<RootState>({
  modules: {
    base: BaseModule,
    localization: LocalizationModule,
    filter: FilterModule,
    search: SearchModule,
  },
  plugins: [vuexLocal.plugin],
});

export default store;
